import { Stack, useTheme } from "@mui/material";
import type { FC, PropsWithChildren } from "react";
import { DetailSectionHeader } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailSectionHeader";

type Props = {
	label: string;
};

export const DetailCard: FC<PropsWithChildren<Props>> = ({
	label,
	children,
}) => {
	const theme = useTheme();

	return (
		<Stack>
			<DetailSectionHeader title={label} />
			<Stack bgcolor={theme.palette.background.paper}>{children}</Stack>
		</Stack>
	);
};
